module.exports = __webpack_public_path__ + "img/img-products-tlt.657db19c.png";